<template>
  <v-container id="user-profile" fluid tag="section">
    <base-material-card
      icon="mdi-map-marker-path"
      :title="
        id
          ? $i18n.t('Edit Booking') + ' - ' + booking.bookingNo
          : $i18n.t('Create Booking')
      "
      v-if="booking"
      class="my-0 small-icon"
    >
      <v-form id="form">
        <v-card>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="3">
                <v-btn-toggle rounded style="float: left; background: transparent;" class="my-4">
                  <v-btn small :color="clientType === 2 ? 'blue' : 'grey'" @click="clientType = 2">
                    <h3 style="padding-right:20px;text-transform: none;">
                      <div style="width:20px;height:12px;float:left" v-if="clientType !== 2"></div>
                      <v-icon v-if="clientType === 2" color="white">mdi-check</v-icon>For Retail
                    </h3>
                  </v-btn>

                  <v-btn small :color="clientType === 1 ? 'blue' : 'grey'" @click="clientType = 1">
                    <h3 style="padding-right:20px;text-transform: none;">
                      <div style="width:20px;height:12px;float:left" v-if="clientType !== 1"></div>
                      <v-icon v-if="clientType === 1" color="white">mdi-check</v-icon>For Corporate
                    </h3>
                  </v-btn>
                </v-btn-toggle>
              </v-col>

              <v-col cols="12" md="3" v-if="clientType === 1">
                <z-client-select v-model="booking.corp_id" :disabled="booking._id !== null" />
              </v-col>

              <v-col cols="12" md="3" v-if="clientType === 1 && booking.corp_id">
                <z-entity-select
                  :corp="booking.corp_id"
                  v-model="booking.clientEntity_id"
                  :label="$i18n.t('Client Entity')"
                  autoSelect
                  hideLone
                />
              </v-col>

              <v-col cols="12" md="3" v-if="clientType === 1 && booking.corp_id">
                <z-entity-select
                  :corp="booking.vendor_id"
                  v-model="booking.clientEntity_id"
                  :label="$i18n.t('Vendor Entity')"
                  autoSelect
                  hideLone
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-0">
          <v-card-title class="subtitle-1">{{ $i18n.t("Passengers") }}</v-card-title>
          <v-card-text class="py-0">
            <v-row v-for="(passenger, index) in booking.passengers" :key="passenger.phone">
              <v-col cols="12" md="3" sm="4">
                <z-customer-autofill v-model="booking.passengers[index]" :label="$i18n.t('Name')" />
              </v-col>

              <v-col cols="12" md="3" sm="4">
                <z-customer-autofill
                  v-model="booking.passengers[index]"
                  email
                  :label="$i18n.t('Email')"
                  hideSearch
                />
              </v-col>
              <v-col cols="12" md="1" sm="2">
                <z-country-select
                  v-model="booking.passengers[index].countryCode"
                  :label="$i18n.t('Country Code')"
                  isd
                  hideName
                  hideFlag
                />
              </v-col>

              <v-col cols="12" md="2" sm="4">
                <v-text-field v-model="booking.passengers[index].phone" :label="$i18n.t('Phone')" />
              </v-col>

              <v-col cols="12" md="1" sm="2">
                <z-gender-select v-model="booking.passengers[index].gender" />
              </v-col>
              <v-col cols="12" md="1" sm="3">
                <v-btn x-small fab text color="teal" class="my-4">
                  <v-icon>mdi-content-save-outline</v-icon>
                </v-btn>
                <v-btn
                  x-small
                  fab
                  text
                  color="red"
                  class="my-4"
                  @click="booking.passengers.splice(index, 1)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-spacer />
              <v-col cols="12" md="1" v-if="index === booking.passengers.length - 1">
                <v-btn x-small fab color="light-blue" class="my-4 float-right" @click="addPax">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="subtitle-1">
            {{
            $i18n.t("Booker")
            }}
          </v-card-title>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="2">
                <z-customer-autofill v-model="bookedBy" :label="$i18n.t('Name')" />
              </v-col>

              <v-col cols="12" md="2">
                <z-customer-autofill v-model="bookedBy" email :label="$i18n.t('Email')" hideSearch />
              </v-col>
              <v-col cols="12" md="1">
                <z-country-select
                  v-model="bookedBy.countryCode"
                  :label="$i18n.t('Country Code')"
                  isd
                  hideName
                  hideFlag
                />
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field v-model="bookedBy.phone" :label="$i18n.t('Phone')" />
              </v-col>

              <v-col cols="12" md="2">
                <v-btn x-small fab text color="teal" class="my-4">
                  <v-icon>mdi-content-save-outline</v-icon>
                </v-btn>
                <v-btn x-small fab text color="red" class="my-4" @click="bookedBy = {}">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-spacer />
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3">
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="2">
                <z-date-picker :label="$i18n.t('Start Date')" v-model="booking.startDate" />
              </v-col>
              <v-col cols="12" md="2">
                <z-time-picker :label="$i18n.t('Start Time')" v-model="booking.startTimeHr" />
              </v-col>
              <v-col cols="12" md="2">
                <z-date-picker :label="$i18n.t('End Date')" v-model="booking.endDate" />
              </v-col>
              <v-col cols="12" md="2">
                <z-time-picker :label="$i18n.t('End Time')" v-model="booking.endTimeHr" />
              </v-col>
              <v-col cols="12" md="2">
                {{
                $i18n.t("Duration") +
                (booking.endTime - booking.startTime) / 60 +
                " Mins"
                }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="3">
                <v-btn-toggle rounded style="float: left; background: transparent;" class="my-4">
                  <v-btn small :color="srcType === 2 ? 'blue' : 'grey'" @click="srcType = 2">
                    <h3 style="padding-right:20px;text-transform: none;">
                      <div style="width:20px;height:12px;float:left" v-if="srcType !== 2"></div>
                      <v-icon v-if="srcType === 2" color="white">mdi-check</v-icon>From Campus
                    </h3>
                  </v-btn>

                  <v-btn small :color="srcType === 1 ? 'blue' : 'grey'" @click="srcType = 1">
                    <h3 style="padding-right:20px;text-transform: none;">
                      <div style="width:20px;height:12px;float:left" v-if="srcType !== 1"></div>
                      <v-icon v-if="srcType === 1" color="white">mdi-check</v-icon>From Address
                    </h3>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" md="3" v-if="srcType == 1">
                <z-address-autofill :label="$i18n.t('Source Adress')" v-model="booking.source" />
              </v-col>
              <v-col cols="12" md="2" v-if="srcType == 1">
                <z-country-select
                  :label="$i18n.t('Source Country')"
                  v-model="booking.source.country"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="srcType == 1">
                <z-city-select
                  :label="$i18n.t('Source City')"
                  v-model="booking.source.city"
                  :country="booking.source.country"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="srcType == 2">
                <z-campus-select
                  :label="$i18n.t('Source Campus')"
                  :corp="booking.corp_id"
                  v-model="booking.fromCampus_id"
                />
              </v-col>
              <v-spacer />
              <v-col cols="12" md="2">
                <v-text-field :label="$i18n.t('Flight/Train No')" v-model="booking.flightNo" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-btn-toggle rounded style="float: left; background: transparent;" class="my-4">
                  <v-btn small :color="dstType === 2 ? 'blue' : 'grey'" @click="dstType = 2">
                    <h3 style="padding-right:20px;text-transform: none;">
                      <div style="width:20px;height:12px;float:left" v-if="dstType !== 2"></div>
                      <v-icon v-if="dstType === 2" color="white">mdi-check</v-icon>To Campus
                    </h3>
                  </v-btn>

                  <v-btn small :color="dstType === 1 ? 'blue' : 'grey'" @click="dstType = 1">
                    <h3 style="padding-right:20px;text-transform: none;">
                      <div style="width:20px;height:12px;float:left" v-if="dstType !== 1"></div>
                      <v-icon v-if="dstType === 1" color="white">mdi-check</v-icon>To Address
                    </h3>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" md="3" v-if="dstType == 1">
                <z-address-autofill
                  :label="$i18n.t('Destination Adress')"
                  v-model="booking.destination"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="dstType == 1">
                <z-country-select
                  :label="$i18n.t('Destination Country')"
                  v-model="booking.destination.country"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="dstType == 1">
                <z-city-select
                  :label="$i18n.t('Destination City')"
                  v-model="booking.destination.city"
                  :country="booking.destination.country"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="dstType == 2">
                <z-campus-select
                  :label="$i18n.t('Source Campus')"
                  :corp="booking.corp_id"
                  v-model="booking.fromCampus_id"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3">
          <v-card-title class="subtitle-1">{{ $i18n.t("Rate") }}</v-card-title>
          <v-card-text class="py-0 text-body-1">
            <v-row>
              <v-col cols="12" md="2">
                <v-img
                  :src="booking.vehicleTypeInfo.pic"
                  height="90"
                  width="120"
                  v-if="booking.vehicleTypeInfo"
                />
              </v-col>
              <v-col cols="12" md="2">{{ booking.vehicleTypeInfo.name }}</v-col>
              <v-col cols="12" md="1">
                {{ booking.clientBilling.fareTariff.name }}
                <br />
                {{ booking.clientBilling.fareTariff.tariffType }}
              </v-col>
              <v-col cols="12" md="2">
                <small>{{ $i18n.t("Base Fare") }}</small>
                <br />
                {{
                booking.clientBilling.fareTariff.currency +
                "" +
                booking.clientBilling.fareTariff.baseFare
                }}
                <br />
                <div v-if="booking.clientBilling.fareTariff.kmFare">
                  <small>{{ $i18n.t("Extra KM Fare") }}</small>
                  <br />
                  {{ booking.clientBilling.fareTariff.kmFare }}
                </div>
              </v-col>
              <v-col cols="12" md="2">
                {{ booking.clientBilling.fareTariff.name }}
                <br />
                {{ booking.clientBilling.fareTariff.tariffType }}
              </v-col>
              <v-col cols="12" md="1">
                <z-rate-select
                  multiple
                  fab
                  text
                  class="purple-input"
                  corp="client"
                  @select="onRateSelect"
                >
                  <v-btn small fab text>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </z-rate-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="subtitle-1">{{ $i18n.t("Trip Details") }}</v-card-title>
          <v-card-text class="py-0 text-body-1">
            <v-row>
              <v-col cols="12" md="1" sm="2">
                <v-text-field v-model="booking.startKm" :label="$i18n.t('Start KM')" />
              </v-col>
              <v-col cols="12" md="1" sm="2">
                <v-text-field v-model="booking.endKm" :label="$i18n.t('End KM')" />
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <v-text-field v-model="booking.garagePickupKMs" :label="$i18n.t('Garage Pick KM')" />
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <v-text-field v-model="booking.garageDropKMs" :label="$i18n.t('Garage Drop KM')" />
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <v-text-field
                  v-model="booking.garagePickupMins"
                  :label="$i18n.t('Garage Pick Minutes')"
                />
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <v-text-field
                  v-model="booking.garageDropMins"
                  :label="$i18n.t('Garage Drop Minutes')"
                />
              </v-col>
              <v-col cols="12" md="2" sm="2">
                <v-text-field v-model="booking.dutySlipNo" :label="$i18n.t('Dutyslip #')" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="subtitle-1">{{ $i18n.t("Fare") }}</v-card-title>
          <v-card-text class="py-0 text-body-1">
            <v-row>
              <v-col cols="12" md="3" style="border-right:1px solid #dfdfdf">
                <v-row>
                  <v-col cols="12" md="9" sm="9">{{ $i18n.t("Charges") }}</v-col>
                  <v-col cols="12" md="3" sm="3">{{ $i18n.t("Amount") }}</v-col>
                </v-row>
                <v-row v-for="item in booking.clientBilling.fare.charges" v-bind:key="item.name">
                  <v-col cols="12" md="9" sm="9">
                    <small>{{ item.name }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">{{ item.amount }}</v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="3"
                v-if="
                  booking.clientBilling.fare.discounts &&
                    booking.clientBilling.fare.discounts.length > 0
                "
                style="border-right:1px solid #dfdfdf"
              >
                <v-row>
                  <v-col cols="12" md="9" sm="9">{{ $i18n.t("Discounts") }}</v-col>
                  <v-col cols="12" md="3" sm="3">{{ $i18n.t("Amount") }}</v-col>
                </v-row>
                <v-row v-for="item in booking.clientBilling.fare.discounts" v-bind:key="item.name">
                  <v-col cols="12" md="9" sm="9">
                    <small>{{ item.name }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">{{ item.amount }}</v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="3" style="border-right:1px solid #dfdfdf">
                <v-row>
                  <v-col cols="12" md="9" sm="9">{{ $i18n.t("Taxes") }}</v-col>
                  <v-col cols="12" md="3" sm="3">{{ $i18n.t("Amount") }}</v-col>
                </v-row>
                <v-row v-for="item in booking.clientBilling.fare.taxes" v-bind:key="item.name">
                  <v-col cols="12" md="9" sm="9">
                    <small>{{ item.name }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">{{ item.amount }}</v-col>
                </v-row>
              </v-col>
              <v-spacer />
              <v-col cols="12" md="3" style="float:right">
                <v-row>
                  <v-col cols="12" md="6" sm="6" class="text-right">{{ $i18n.t("Sub Total") }}</v-col>
                  <v-col cols="12" md="6" sm="6" class="text-right">
                    {{ booking.clientBilling.fare.subTotal }}
                    <small>{{ booking.clientBilling.fare.currency }}</small>
                  </v-col>
                  <v-col cols="12" md="6" sm="6" class="text-right">{{ $i18n.t("Discount Total") }}</v-col>
                  <v-col cols="12" md="6" sm="6" class="text-right">
                    {{ booking.clientBilling.fare.totalDiscounts }}
                    <small>{{ booking.clientBilling.fare.currency }}</small>
                  </v-col>
                  <v-col cols="12" md="6" sm="6" class="text-right">{{ $i18n.t("Taxes Total") }}</v-col>
                  <v-col cols="12" md="6" sm="6" class="text-right">
                    {{ booking.clientBilling.fare.totalTaxes }}
                    <small>{{ booking.clientBilling.fare.currency }}</small>
                  </v-col>

                  <v-col cols="12" md="6" sm="6" class="text-right">
                    <b>{{ $i18n.t("Total") }}</b>
                  </v-col>
                  <v-col cols="12" md="6" sm="6" class="text-right">
                    <b>
                      {{ booking.clientBilling.fare.total }}
                      <small>{{ booking.clientBilling.fare.currency }}</small>
                    </b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3">
          <v-card-title class="subtitle-1">
            {{
            $i18n.t("Vehicle/Driver")
            }}
          </v-card-title>
          <v-card-text class="py-0 text-body-1">
            <v-row>
              <v-col cols="12" md="1">
                <v-img
                  :src="booking.vehicleTypeInfo.pic"
                  height="60"
                  width="80"
                  v-if="booking.vehicleTypeInfo"
                />
              </v-col>

              <v-col cols="12" md="4">
                <z-vehicle-select
                  :value="booking.vehicle"
                  :label="Vehicle"
                  @input="onVehicleChange"
                />
              </v-col>

              <!-- <v-col cols="12" md="2">
                {{ booking.vehicleTypeInfo.name }}
                <br />
                {{ booking.vehicle.regNo }}
              </v-col>-->

              <!-- <v-col cols="12" md="2">
                {{ booking.vehicleTypeInfo.name }}
              </v-col>-->

              <v-col cols="12" md="1">
                <v-img :src="booking.driver.pic" height="60" width="80" v-if="booking.driver" />
              </v-col>

              <v-col cols="12" md="4">
                <z-driver-select v-model="booking.driver._id" :label="Driver" />
              </v-col>

              <!-- <v-col cols="12" md="2">
                {{ booking.driver.name }}
                <br />
                +{{ booking.driver.countryCode }}-{{ booking.driver.phone }}
              </v-col>
              <v-col cols="12" md="2">
                {{ booking.vehicleTypeInfo.name }}
              </v-col>-->
            </v-row>
          </v-card-text>
        </v-card>

        <v-container class="py-0">
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </base-material-card>

    <v-dialog v-model="vehicleUpdate" color="white" width="400">
      <v-card>
        <v-card-text>{{ vehicleUpdateText }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text fab small @click="onVehicleUpdateYes()">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn color="red" text fab small v-bind="attrs" @click="onVehicleUpdateNo()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class BookingEdit extends Vue {
  booking = {
    bookingNo: "",
    corp_id: null,
    source: { country: "", state: "", city: "", addressLine: "" },
    destination: { country: "", state: "", city: "", addressLine: "" },
  };

  clientType = 1;
  srcType = 1;
  dstType = 1;
  bookedBy = {};
  rate = {};
  id = null;
  vehicleUpdate = false;
  vehicleUpdateText = "Confirm Vehicle Update";
  oldVeh = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      this.booking.bookedBy = this.bookedBy;
      this.booking = await doPost("/api/booking/save/return", this.booking);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.booking = await doGet("/api/corp/booking/" + id + "/detail");
      this.id = this.booking._id;
      if (this.booking.bookedBy) this.bookedBy = this.booking.bookedBy;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  addPax() {
    this.booking.passengers.push({});
  }

  onRateSelect(rate) {
    this.rate = rate;
  }

  onVehicleChange(newVal) {
    const oldVal = this.booking.vehicle;
    this.vehicleUpdate = true;
    if (newVal == null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t(
        "Confirm vehicle to be unassigned !"
      );
    }
    if (newVal != null && oldVal == null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm vehicle assignment !");
    }
    if (newVal != null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm vehicle replace !");
    }
    this.oldVeh = oldVal;
    this.booking.vehicle = newVal;
  }

  async onVehicleUpdateYes() {
    this.vehicleUpdate = false;
    //TODO call respective API
  }

  onVehicleUpdateNo() {
    this.vehicleUpdate = false;
    this.booking.vehicle = this.oldVeh;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
